import type SitApi from "../../SitApit";
import {makeAutoObservable} from "mobx";
import {sitStores} from "../../../stores";
import type {FinancialDashboardStore} from "../../stores/FinancialDashboardStore";
import {DOIs, type PipelineStage} from "../../ApiTypes";
import {stageGateLabel} from "../../sitLabels";

class PipelineDashboardController {

    constructor(
        private api: SitApi,
        private fb: FinancialDashboardStore,
    ) {
        makeAutoObservable(this, {});
    }

    /**
     * Per stage, the savings of the initiatives that had reached it by the end of each compared month: the
     * pipeline then and now (`initiatives/pipeline/`), probability-weighted when that filter is on. Labelled with the
     * answer's own days, so a result still shown while the next one loads keeps its own months.
     */
    getStageCmp(kind: 'saving' | 'avoidance'): {DOI: string, source: [string, number][]}[] | null {
        const result = this.fb.pipelineRM.result;
        if (!result) return null;
        const field: keyof PipelineStage = this.fb.probabilityAdjusted ? `${kind}_adj` : kind;
        const days = [...result.dates].sort((a, b) => a.date.localeCompare(b.date));
        return DOIs.map(doi => ({
            DOI: stageGateLabel(doi),
            source: days.map(d => [
                d.date.slice(0, 7),
                Number(d.stages.find(s => s.doi === doi)?.[field] ?? 0),
            ]),
        }));
    }

    get ppvSavings() {
        return this.getStageCmp('saving');
    }

    get nonPpvSavings() {
        return this.getStageCmp('avoidance');
    }
}

export default new PipelineDashboardController(sitStores.sitApi, sitStores.fbStore);
